import { User, UserFormData, UserType } from '../types';
import { apiClient } from './apiClient';

// User Service
export class UserService {
  // Create a new user
  static async createUser(userData: UserFormData): Promise<User> {
    const response = await apiClient.post('/users', userData);
    return response.data;
  }

  // Get all users
  static async getAllUsers(): Promise<User[]> {
    const response = await apiClient.get('/users');
    return response.data;
  }

  // Get user by phone number
  static async getUserByPhoneNumber(phoneNumber: string): Promise<User> {
    const response = await apiClient.get(`/users/phone/${phoneNumber}`);
    return response.data;
  }

  // Get user by email
  static async getUserByEmail(email: string): Promise<User> {
    const response = await apiClient.get(`/users/email/${email}`);
    return response.data;
  }

  // Get users by type
  static async getUsersByType(userType: UserType): Promise<User[]> {
    const response = await apiClient.get(`/users/type/${userType}`);
    return response.data;
  }

  // Update user
  static async updateUser(phoneNumber: string, userData: Partial<UserFormData>): Promise<User> {
    const response = await apiClient.put(`/users/phone/${phoneNumber}`, userData);
    return response.data;
  }

  // Delete user account
  static async deleteUser(phoneNumber: string, userPhone?: string): Promise<void> {
    const headers: any = {};
    if (userPhone) {
      headers['X-User-Phone'] = userPhone;
    }
    await apiClient.delete(`/users/phone/${phoneNumber}`, { headers });
  }

  // Get user count
  static async getUserCount(): Promise<number> {
    const response = await apiClient.get('/users/count');
    return response.data;
  }
}

export default UserService;
